import React from 'react';
import { Tooltip, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    ListViewRequestTypes, RequestSubtypes,
} from '../../../../../Enums';
import './RequestTypeChip.scss';

/**
 * 
 * @param {typeof import("../../../../../Enums/RequestType").RequestTypes} type 
 * @param {boolean} isMyRequest 
 * @returns 
 */
const getChipClass = (type, isMyRequest) => {
    if(isMyRequest){
        return 'myRequestChipFormatting';
    }
    switch (type) {
        case ListViewRequestTypes.myPaycode:
            return 'paycodeChipFormatting';
        case ListViewRequestTypes.myShift:
            return 'shiftChipFormatting';
        case ListViewRequestTypes.toCover:
            return 'chipTC';
        case ListViewRequestTypes.shiftSwap:
            return 'chipSS';
        case ListViewRequestTypes.openShift:
            return 'chipOS';
        case ListViewRequestTypes.voluntaryTimeOff:
            return 'chipVTO';
        default:
            return 'shiftChipFormatting';
    }
}
const getTooltip = (listItem) => {
    let content;
    switch (listItem.type) {
        case -2: //My Paycode
            content = (
                <div className='tooltip-text'>
                    <div> My Paycode</div>
                </div>
            );
            break;
        case -1: //My Shift
            content = (
                <div className='tooltip-text'>
                    <div> My Shift</div>
                </div>
            );
            break;
        case ListViewRequestTypes.toCover:
            content = 'To Cover';
            break;
        case ListViewRequestTypes.shiftSwap:
            content = 'Shift Swap';
            break;
        case ListViewRequestTypes.openShift:
            if (listItem?.subtype === RequestSubtypes.signUp) {
                content = (
                    <div className='tooltip-text'>
                        <div> Open shift sign-up request </div>
                    </div>
                );
                break;
            }
            content = 'Fill open shift';
            break;
        case ListViewRequestTypes.voluntaryTimeOff:
            if (listItem?.subtype === RequestSubtypes.signUp) {
                content = (
                    <div className='tooltip-text'>
                        <div> Voluntary time-off sign-up request </div>
                    </div>
                );
                break;
            }
            content = (
                <div className='tooltip-text'>
                    <div> Fill voluntary time-off request </div>
                </div>
            );
            break;
        default:
            content = '';
    }
    return (
        <div className='tooltip-text'>
            {content}
        </div>);
}
const WarnTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ tooltip: className }} />
))({
    backgroundColor: 'white',
    color: '#3A3A3A',
    maxWidth: '520px',
    border: '1px solid #dadde9',
});

/**
 * 
 * @param {{listItem: import('../BillboardListView.helpers').IListViewItem}} param0 
 */
const RequestTypesChip = ({ listItem }) => {
    return (
        <React.Fragment>
            <WarnTooltip
                title={getTooltip(listItem)}
            >
                <Chip className={getChipClass(listItem.type, listItem.isMyRequest)} label={listItem.requestName}></Chip>
            </WarnTooltip>
        </React.Fragment>
    );
}

export default RequestTypesChip;
